import { HistoryPanel } from "./HistoryPanel";
import { UserProfilePanel } from "./UserProfilePanel";
import { SettingsPanel } from "./SettingsPanel";
import type { User } from "@supabase/supabase-js";
import { Message } from "@/types/message";
import { CurrentFocusContainerMemento } from "@/types/memento";
import { DragEndEvent, SensorDescriptor, SensorOptions } from '@dnd-kit/core';
import type { ActivityView } from "./ActivityBar";

interface SidePanelProps {
  activeView: ActivityView;
  user: User | null;
  messages: Message[];
  mementos: CurrentFocusContainerMemento[];
  activeTab: string;
  onTabChange: (tab: string) => void;
  onFocusEditor: (messageId: string) => void;
  onLoadMemento: (memento: CurrentFocusContainerMemento) => void;
  onPin: (messageId: string, pinned: boolean) => Promise<void>;
  onFavorite: (messageId: string, favorited: boolean) => Promise<void>;
  onDelete: (messageId: string) => Promise<void>;
  onPinMemento: (mementoId: string) => Promise<void>;
  onFavoriteMemento: (mementoId: string) => Promise<void>;
  onDeleteMemento: (mementoId: string) => Promise<void>;
  onLoadMoreMementos: () => void;
  hasMoreMementos: boolean;
  loadingMementos: boolean;
  sensors: SensorDescriptor<SensorOptions>[];
  onDragEnd: (event: DragEndEvent) => void;
  onSignOut: () => void;
  onSignIn: () => void;
  isSigningOut: boolean;
}

export function SidePanel({
  activeView,
  user,
  messages,
  mementos,
  activeTab,
  onTabChange,
  onFocusEditor,
  onLoadMemento,
  onPin,
  onFavorite,
  onDelete,
  onPinMemento,
  onFavoriteMemento,
  onDeleteMemento,
  onLoadMoreMementos,
  hasMoreMementos,
  loadingMementos,
  sensors,
  onDragEnd,
  onSignOut,
  onSignIn,
  isSigningOut,
}: SidePanelProps) {
  return (
    <div className="h-full w-full bg-background flex flex-col overflow-hidden min-w-0">
      {/* Panel Content */}
      <div className="flex-1 min-h-0 overflow-hidden flex flex-col min-w-0">
        {activeView === "history" && (
          <HistoryPanel
            messages={messages}
            mementos={mementos}
            activeTab={activeTab}
            onTabChange={onTabChange}
            onFocusEditor={onFocusEditor}
            onLoadMemento={onLoadMemento}
            onPin={onPin}
            onFavorite={onFavorite}
            onDelete={onDelete}
            onPinMemento={onPinMemento}
            onFavoriteMemento={onFavoriteMemento}
            onDeleteMemento={onDeleteMemento}
            onLoadMoreMementos={onLoadMoreMementos}
            hasMoreMementos={hasMoreMementos}
            loadingMementos={loadingMementos}
            sensors={sensors}
            onDragEnd={onDragEnd}
          />
        )}
        
        {activeView === "user" && (
          <UserProfilePanel
            user={user}
            onSignOut={onSignOut}
            onSignIn={onSignIn}
            isSigningOut={isSigningOut}
          />
        )}
        
        {activeView === "settings" && (
          <SettingsPanel />
        )}
      </div>
    </div>
  );
}
